export default [
    {
        path: '/certificate-operation-prints',
        name: 'certificate-operation-print',
        meta: { requiresAuth: true },
        component: () => import('@/pages/certificate-operation-print/index.vue')
    }
]
